import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2Icon, XIcon } from 'lucide-react';
import { productShortName } from '../data/offer';
export function PurchaseNotification() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const show = window.setTimeout(() => setVisible(true), 5000);
    const hide = window.setTimeout(() => setVisible(false), 15000);
    return () => {
      window.clearTimeout(show);
      window.clearTimeout(hide);
    };
  }, []);
  return <AnimatePresence data-id="element-168" data-mp="21yd8ya0c84tx">
      {visible && <motion.aside initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: 14
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed bottom-4 right-4 z-50 w-[calc(100%-2rem)] max-w-sm rounded-xl border border-steel/30 border-l-4 border-l-copper bg-navy-900 p-4 pr-10 text-white shadow-2xl shadow-black/50" aria-live="polite" data-id="element-169" data-mp="1wyh3e6bzs5c9">
          <button type="button" onClick={() => setVisible(false)} className="absolute right-2 top-2 rounded p-1 text-steel-light transition-colors duration-150 ease-out hover:text-white focus:outline-none focus-visible:ring-2 focus-visible:ring-gold" aria-label="Dismiss notice" data-id="element-170" data-mp="1sh7kcrid1u2j">
            <XIcon className="h-4 w-4" data-id="element-171" data-mp="1ng1qurgvm2ry" />
          </button>
          <div className="flex gap-3" data-id="element-172" data-mp="1ninz6tblcmb8">
            <CheckCircle2Icon className="mt-0.5 h-5 w-5 shrink-0 text-copper" aria-hidden="true" data-id="element-173" data-mp="19p4y90my9lkw" />
            <div data-id="element-174" data-mp="1egempxwriiv7">
              <p className="text-[10px] font-extrabold uppercase tracking-[.16em] text-copper" data-id="element-175" data-mp="1egwthoh1wfhd">Access confirmed</p>
              <p className="mt-1 text-sm leading-snug text-steel-light" data-id="element-176" data-mp="zt20s831mb4a">
                Once your purchase is complete you receive the
                <br data-id="element-177" data-mp="qqsq9i7ryhqw" />
                <span className="font-bold text-white" data-id="element-178" data-mp="qqan01mp339h">{productShortName}</span>
              </p>
              <p className="mt-2 text-xs text-steel-light" data-id="element-179" data-mp="vpwxw4f1w7f4">Instant digital access by email.</p>
            </div>
          </div>
        </motion.aside>}
    </AnimatePresence>;
}